import { PortableText, PortableTextReactComponents } from "@portabletext/react";

import { Text } from "@/components/elements";

import styles from "./styles.module.css";
const IntroComponent: Partial<PortableTextReactComponents> = {
  block: ({ children }) => (
    <Text size="l" responsive className={styles.intro}>
      {children}
    </Text>
  ),
};

export const Intro = ({ value }) => (
  <>
    <PortableText value={value} components={IntroComponent} />
    <hr className={styles.hr} />
  </>
);
